module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-163.e959371d.svg";